export default "__VITE_ASSET__C6jAW$nw__"